
import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';



export const fetchAllPaySlipReport = createAsyncThunk(
    'report/fetchAllPaySlipReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/report/payslip');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all PaySlip');
        }
    }
);

export const fetchAllPaySlipReportDetails = createAsyncThunk(
    'report/fetchAllPaySlipReportDetails',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/report/payslip/details');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all PaySlip Details');
        }
    }
);



export const fetchAllPaySlipReportDetailsMonthly = createAsyncThunk(
    'report/fetchAllPaySlipReportDetails',
    async (year: string , { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/payslip/monthlycount/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all PaySlip Details Monthly');
        }
    }
);